<template>
  <div>
    <validation-observer ref="simpleRules">
      <b-row class="match-height">
        <div class="col-md-12">
          <div>
            <div class="p-2">
              <router-link to="/admin/finance/receipt">
                <b-button
                  variant="primary"
                  class="mr-50 col-md-2"
                >
                  {{ $t('returnToList') }}
                </b-button>
              </router-link>
            </div>
          </div>
        </div>
      </b-row>
      <b-row class="match-height col-md-12">
        <div class="row match-height ">
          <div class="col-md-4 mb-0">
            <div class="card p-2">
              <div class="header-cardx p-2 mb-2">
                <h4 class="mb-0">
                  {{ $t('details') }}
                </h4>
              </div>
              <div>
                <div class="d-flex align-items-left mb-1">
                  <div>
                    <p class="mb-0 font-weight-bolder text-left mr-2">
                      {{ $t('receiptNumber') }} :
                    </p>
                  </div>

                  <div>
                    {{ items.billnumber }}
                  </div>
                </div>

                <div class="d-flex align-items-left mb-1">
                  <div>
                    <p class="mb-0 font-weight-bolder text-left mr-2">
                      {{ $t('status') }} :
                    </p>
                  </div>

                  <div
                    v-if="items.statusbill === 1"
                    class="w-80 badge badge-light-success "
                  >
                    {{ $t('operationCompleted') }}
                  </div>
                  <div
                    v-else-if="items.statusbill === 2"
                    class="w-50 badge badge-light-danger col-md-3"
                  >
                    {{ $t('cancelled') }}
                  </div>
                  <div
                    v-else
                    class="w-50 badge badge-light-primary col-md-3"
                  >
                    {{ $t('pendingReview') }}
                  </div>
                </div>
                <div class="d-flex align-items-left mb-1">
                  <div>
                    <p class="mb-0 font-weight-bolder text-left mr-2">
                      {{ $t('transactionDate') }} :
                    </p>
                  </div>

                  <div>
                    {{ time(items.created_at) }}
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="col-md-8 mb-0">
            <div>
              <div class="card p-2">
                <div class="header-cardx p-2 mb-2">
                  <h4 class="mb-0">
                    {{ $t('listReceipts') }}
                  </h4>
                </div>
                <div class="table-container">
                  <table class="styled-table mt-n25">
                    <thead>
                      <tr>
                        <th scope="col">
                          {{ $t('transactionDate') }}
                        </th>
                        <th
                          class="text-left"
                          scope="col"
                        >
                          {{ $t('receiptNumber') }}
                        </th>
                        <th scope="col">
                          {{ $t('name') }}
                        </th>
                        <th scope="col">
                          {{ $t('TaxID') }}
                        </th>
                        <th
                          class="text-left"
                          scope="col"
                        >
                          {{ $t('quantity') }}
                        </th>
                        <th scope="col">
                          {{ $t('status') }}
                        </th>
                      </tr>
                    </thead>
                    <thead>
                      <tr style="background: #fff; color: black;">
                        <th
                          class="text-center"
                          scope="col"
                          style="background: #fff; color: black;"
                        >
                          {{ time(items.created_at) }}
                        </th>
                        <th
                          class="text-center"
                          scope="col"
                          style="background: #fff; color: black;"
                        >
                          {{ items.billnumber }}
                        </th>
                        <th
                          class="text-center"
                          scope="col"
                          style="background: #fff; color: black;"
                        >
                          {{ items.texfullname }}
                        </th>
                        <th
                          class="text-center"
                          scope="col"
                          style="background: #fff; color: black;"
                        >
                          {{ items.texnumber }}
                        </th>
                        <th
                          class="text-center"
                          scope="col"
                          style="background: #fff; color: black;"
                        >
                          <span class="text-success">+{{ Commas(arritem.reduce((total, data) => total + data.sumitem, 0))
                          }} ฿</span>

                        </th>
                        <th
                          class="text-center"
                          scope="col"
                          style="background: #fff; color: black;"
                        >

                          <span
                            v-if="items.statusbill === 1"
                            class="badge badge-light-success badge-pill"
                          > {{
                            $t('operationCompleted') }} </span>
                          <span
                            v-else-if="items.statusbill === 2"
                            class="badge badge-light-danger badge-pill"
                          > {{
                            $t('cancelled') }} </span>
                          <span
                            v-else
                            class="badge badge-light-primary badge-pill "
                          > {{ $t('pendingReview') }} </span>

                        </th>

                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-row>
      <b-row class="match-height">
        <div class="row match-height">
          <div
            v-if="items.statusbill === 1"
            class="col-md-12 mb-2"
          >
            <div>

              <b-button
                variant="warning"
                class="mr-50 col-md-2"
                @click="cancelsubmit()"
              >
                {{ $t('ChangeToWaitVerify') }}
              </b-button>

              <b-button
                v-if="items.statusprint"
                variant="danger"
                class="mr-50 col-md-2"
                @click="submitprint()"
              >
                {{ $t('recordNotprinted') }}
              </b-button>
              <b-button
                v-else
                variant="warning"
                class="mr-50 col-md-2"
                @click="submitprint()"
              >
                {{ $t('recordPrinted') }}
              </b-button>

              <b-button
                variant="secondary"
                class="mr-50 col-md-2"
                @click="printbill()"
              >
                {{ $t('print') }}
              </b-button>
              <b-button
                variant="danger"
                class="mr-50 col-md-2 mb-1"
                @click="cancelbill()"
              >
                {{ $t('cancelOrder') }}
              </b-button>
            </div>
          </div>
          <div
            v-else-if="items.statusbill === 2"
            class="col-md-12 mb-2"
          >
            <div class="gap-5">
              <!-- <b-button
                variant="primary"
                class="mr-50 col-md-2 mb-1"
                @click="Submit()"
              >
                {{ $t('save') }}
              </b-button> -->

              <!-- <b-button
                variant="success"
                class="mr-50 col-md-2 mb-1"
                @click="Submitokay()"
              >
                {{ $t('ApproveList') }}
              </b-button> -->

              <b-button
                v-if="items.statusprint"
                variant="danger"
                class="mr-50 col-md-2 mb-1"
                @click="submitprint()"
              >
                {{ $t('recordNotprinted') }}
              </b-button>
              <b-button
                v-else
                variant="warning"
                class="mr-50 col-md-2 mb-1"
                @click="submitprint()"
              >
                {{ $t('recordPrinted') }}
              </b-button>

              <b-button
                variant="secondary"
                class="mr-50 col-md-2 mb-1"
                @click="printbill()"
              >
                {{ $t('print') }}
              </b-button>
            </div>
          </div>
          <div
            v-else
            class="col-md-12 mb-2"
          >
            <div class="gap-5">
              <b-button
                variant="primary"
                class="mr-50 col-md-2 mb-1"
                @click="Submit()"
              >
                {{ $t('save') }}
              </b-button>

              <b-button
                variant="success"
                class="mr-50 col-md-2 mb-1"
                @click="Submitokay()"
              >
                {{ $t('ApproveList') }}
              </b-button>

              <b-button
                v-if="items.statusprint"
                variant="danger"
                class="mr-50 col-md-2 mb-1"
                @click="submitprint()"
              >
                {{ $t('recordNotprinted') }}
              </b-button>
              <b-button
                v-else
                variant="warning"
                class="mr-50 col-md-2 mb-1"
                @click="submitprint()"
              >
                {{ $t('recordPrinted') }}
              </b-button>

              <b-button
                variant="secondary"
                class="mr-50 col-md-2 mb-1"
                @click="printbill()"
              >
                {{ $t('print') }}
              </b-button>
              <b-button
                variant="danger"
                class="mr-50 col-md-2 mb-1"
                @click="cancelbill()"
              >
                {{ $t('cancelOrder') }}
              </b-button>
            </div>
          </div>
        </div>
      </b-row>
      <div class="receipt-preview-wrap">
        <div class="receipt-preview-bar">
          <div>
            <h4 class="mb-0">ตัวอย่างใบเสร็จรับเงิน</h4>
            <p class="mb-0">แก้ไขข้อมูลลูกค้าแล้วดูผลบนเอกสารทันที</p>
          </div>
          <a
            href="/receipt-example.html"
            target="_blank"
            rel="noopener"
            class="receipt-example-link"
          >
            เปิดตัวอย่างข้อมูลสมมติ
          </a>
        </div>

        <article
          id="receipt-print-area"
          ref="receiptPaper"
          class="receipt-paper"
        >
          <header class="receipt-header">
            <div class="receipt-brand">
              <img
                src="@/assets/images/logo/logo-p2-cargo.webp"
                alt="P2 CARGO"
                class="receipt-logo"
              >
              <div class="receipt-company">
                <h2>{{ companyName }}</h2>
                <p>ที่อยู่ {{ companyAddress }}</p>
                <p>โทรศัพท์ {{ companyPhone }}</p>
                <p>เลขประจำตัวผู้เสียภาษี {{ companyTax }} / สำนักงานใหญ่</p>
              </div>
            </div>
            <div class="receipt-title">
              <h2>ใบเสร็จรับเงิน</h2>
              <span>Page 1 of 1</span>
            </div>
          </header>

          <section class="receipt-meta">
            <div class="receipt-box">
              <div class="receipt-row">
                <span class="receipt-label">นามลูกค้า</span>
                <div class="receipt-value">
                  <p class="receipt-name-flow">
                    <span
                      class="receipt-edit-text"
                      contenteditable="true"
                      spellcheck="false"
                      @blur="texfullname = $event.target.innerText.trim()"
                    >{{ texfullname }}</span><span> / เลขผู้เสียภาษี </span><span
                      class="receipt-edit-text"
                      contenteditable="true"
                      spellcheck="false"
                      @blur="texnumber = $event.target.innerText.trim()"
                    >{{ texnumber }}</span>
                  </p>
                  <validation-provider
                    #default="{ errors }"
                    name="texfullname"
                    rules="required"
                  >
                    <input
                      v-model="texfullname"
                      type="hidden"
                    >
                    <small
                      v-if="errors[0]"
                      class="text-danger"
                    >{{ $t('requiredField') }}</small>
                  </validation-provider>
                  <validation-provider
                    #default="{ errors }"
                    name="texnumber"
                    rules="required"
                  >
                    <input
                      v-model="texnumber"
                      type="hidden"
                    >
                    <small
                      v-if="errors[0]"
                      class="text-danger"
                    >{{ $t('requiredField') }}</small>
                  </validation-provider>
                </div>
              </div>
              <div class="receipt-row">
                <span class="receipt-label">ที่อยู่</span>
                <validation-provider
                  #default="{ errors }"
                  name="addresstex"
                  rules="required"
                  class="receipt-field"
                >
                  <b-form-textarea
                    id="h-address"
                    v-model="addresstex"
                    class="receipt-input receipt-textarea"
                    rows="2"
                    :state="errors.length > 0 ? false : null"
                    placeholder="ที่อยู่สำหรับออกใบเสร็จ"
                  />
                  <small
                    v-if="errors[0]"
                    class="text-danger"
                  >{{ $t('requiredField') }}</small>
                </validation-provider>
              </div>
              <div class="receipt-row">
                <span class="receipt-label">หมายเหตุ</span>
                <span class="receipt-value">-</span>
              </div>
              <div class="receipt-row">
                <span class="receipt-label">เลขที่ใบชำระเงิน</span>
                <router-link
                  v-if="items._id"
                  :to="{ name: 'shipment_payment_edit', params: { id: items._id } }"
                  target="_blank"
                  class="receipt-value receipt-link"
                >
                  {{ items.itemnumber_text || '-' }}
                </router-link>
                <span
                  v-else
                  class="receipt-value"
                >-</span>
              </div>
              <div class="receipt-row">
                <span class="receipt-label">เบอร์โทร</span>
                <validation-provider
                  #default="{ errors }"
                  name="purchase-order"
                  rules="required"
                  class="receipt-field"
                >
                  <b-form-input
                    v-model="telephone"
                    type="number"
                    class="receipt-input"
                    :state="errors.length > 0 ? false : null"
                    placeholder="08xxxxxxxx"
                  />
                  <small
                    v-if="errors[0]"
                    class="text-danger"
                  >{{ $t('requiredField') }}</small>
                </validation-provider>
              </div>
            </div>

            <div class="receipt-box">
              <div class="receipt-row">
                <span class="receipt-label">วันที่</span>
                <span class="receipt-value">{{ times(items.updated_at) }}</span>
              </div>
              <div class="receipt-row">
                <span class="receipt-label">เลขที่ใบเสร็จรับเงิน</span>
                <span class="receipt-value">{{ items.billnumber || '-' }}</span>
              </div>
              <div class="receipt-row">
                <span class="receipt-label">พนักงานขาย</span>
                <span class="receipt-value">-</span>
              </div>
              <div class="receipt-row">
                <span class="receipt-label">วันที่ครบกำหนด</span>
                <span class="receipt-value">-</span>
              </div>
              <div class="receipt-row">
                <span class="receipt-label">การชำระเงิน</span>
                <span class="receipt-value">เงินสด</span>
              </div>
              <div class="receipt-row">
                <span class="receipt-label">วิธีการจัดส่ง</span>
                <span class="receipt-value">-</span>
              </div>
            </div>
          </section>

          <table class="receipt-table">
            <thead>
              <tr>
                <th class="col-code">รหัสสินค้า<small>Code</small></th>
                <th class="col-desc">คำอธิบาย<small>Description</small></th>
                <th class="col-qty">จำนวน<small>Qty</small></th>
                <th class="col-unit">ราคา/หน่วย<small>Unit</small></th>
                <th class="col-disc">ส่วนลด<small>Discount</small></th>
                <th class="col-amt">จำนวนเงิน<small>Amount</small></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in displayItems"
                :key="index"
              >
                <td class="col-code">{{ item.code }}</td>
                <td class="col-desc">{{ item.description }}</td>
                <td class="col-qty">{{ item.empty ? '' : (item.quantity || 1) }}</td>
                <td class="col-unit">{{ item.empty ? '' : Commas(item.payment) }}</td>
                <td class="col-disc">{{ item.empty ? '' : Commas(item.difference) }}</td>
                <td class="col-amt">{{ item.empty ? '' : Commas(item.sumitem) }}</td>
              </tr>
              <tr class="receipt-total-row">
                <td
                  colspan="3"
                  class="receipt-baht-text"
                >
                  ({{ thaiBahtText }})
                </td>
                <td
                  colspan="3"
                  class="receipt-net-cell"
                >
                  <div class="receipt-net-box">
                    <span class="receipt-net-label">ยอดเงินสุทธิ</span>
                    <strong>{{ Commas(netTotal) }}</strong>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <p class="receipt-note">
            ถ้าชื่อที่อยู่ไม่ถูกต้อง โปรดแจ้งภายใน 7 วันหลังจากเปิดบิล มิฉะนั้นจะถือว่าสมบูรณ์
          </p>

          <div class="receipt-pay">
            <span>ชำระโดย :</span>
            <span><i class="receipt-chk" />เงินสด</span>
            <span><i class="receipt-chk" />เช็คธนาคาร</span>
          </div>

          <div class="receipt-bank">
            <span>ธนาคาร <em /></span>
            <span>สาขา <em /></span>
            <span>เลขที่ <em /></span>
            <span>ลงวันที่ ....../....../......</span>
          </div>

          <footer class="receipt-signs">
            <div
              v-for="role in signRoles"
              :key="role"
              class="receipt-sign"
            >
              <p>{{ role }}</p>
              <div class="receipt-sign-space" />
              <span>วันที่ ....../....../......</span>
            </div>
          </footer>
        </article>
      </div>
    </validation-observer>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment-timezone'
import {
  BFormInput, BFormGroup, BFormTextarea, BButton,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {

    BFormInput,
    BFormGroup,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    // vSelect,
    // BFormRadio,
    // BFormCheckbox,
    // BPagination,
    // BLink,
    // BModal,
    // BTable,
    // BSpinner,
    BButton,
  },
  data() {
    return {
      search: '',
      isActive: 'all',
      selectedRadio: 'active',
      optionsRadio: [
        { text: 'All', value: 'all' },
        { text: 'Car', value: 'car' },
        { text: 'Ship', value: 'ship' },
      ],
      pageOptions: [5, 10, 15, 20],
      currentPage: 1,
      perPage: 5,
      totalRows: 1,
      // fields: [
      //   {
      //     key: 'billnumber', label: 'หมายเลข', thStyle: { width: '10%' }, thClass: 'text-center',
      //   },
      //   {
      //     key: 'itemnumber_text', label: 'เลขที่ใบส่งของ', sortable: false, thStyle: { width: '10%' }, thClass: 'text-center',
      //   },
      //   {
      //     key: 'username', label: 'ลูกค้า', sortable: false, thStyle: { width: '5%' }, thClass: 'text-center', tdClass: 'text-center',
      //   },
      //   {
      //     key: 'created_at', label: 'วันที่ทำรายการ', sortable: false, thStyle: { width: '10%' }, thClass: 'text-center', tdClass: 'text-center',
      //   },
      //   {
      //     key: 'updated_at', label: 'วันที่อนุมัติ', sortable: false, thStyle: { width: '10%' }, thClass: 'text-center', tdClass: 'text-center',
      //   },
      //   {
      //     key: 'texfullname', label: 'นาม', sortable: false, thStyle: { width: '15%' }, thClass: 'text-center',
      //   },
      //   {
      //     key: 'filetex', label: 'เอกสาร', sortable: false, thStyle: { width: '5%' }, thClass: 'text-center', tdClass: 'text-center',
      //   },
      //   {
      //     key: 'typetex', label: 'ประเภทลูกค้า', sortable: false, thStyle: { width: '10%' }, thClass: 'text-center', tdClass: 'text-center',
      //   },
      //   {
      //     key: 'payment', label: 'จำนวน', sortable: false, thStyle: { width: '10%' }, thClass: 'text-center', tdClass: 'text-right',
      //   },
      //   {
      //     key: 'statusbill', label: 'สถานะ', sortable: false, thStyle: { width: '10%' }, thClass: 'text-center', tdClass: 'text-center',
      //   },
      //   {
      //     key: 'actions', label: 'actions', sortable: false, thStyle: { width: '5%' }, thClass: 'text-center', tdClass: 'text-center',
      //   },
      // ],
      items: [
        // {
        //   id: 1,
        //   number: 'GUSR-0001',
        //   deliveryNumber: 'GUSR-0001',
        //   customer: 'GUSR-0001',
        //   transactionDate: 'GUSR-0001',
        //   approvalDate: '-',
        //   noun: 'บริษัท ชิดา คอมเมอร์เชียล (ประเทศไทย) จำกัด',
        //   document: 'https://plmcdn.azureedge.net/upload/images/receipt/7a796ac0.jpg',
        //   customerType: 'บุคคลธรรมดา',
        //   amount: 100000,
        //   status: 'waiting',
        // },

        // {
        //   id: 2,
        //   number: 'GUSR-0001',
        //   deliveryNumber: 'GUSR-0001',
        //   customer: 'GUSR-0001',
        //   transactionDate: 'GUSR-0001',
        //   approvalDate: '-',
        //   noun: 'บริษัท ชิดา คอมเมอร์เชียล (ประเทศไทย) จำกัด',
        //   document: 'https://plmcdn.azureedge.net/upload/images/receipt/72655903.jpg',
        //   customerType: 'นิติบุคคล',
        //   amount: 100000,
        //   status: 'success',
        // },
      ],
      pic: null,

      total: 0,
      notpaid: 0,
      waitingforcheck: 0,
      waitingforpayment: 0,
      paid: 0,
      OrderSuccess: 0,
      completetrack: 0,
      completewarehouse: 0,
      cancel: 0,
      ID: this.$route.params.id,
      texfullname: null,
      addresstex: null,
      telephone: null,
      texnumber: null,
      arritem: [],
      required,
      letterhead: {
        company_address: '',
        taxpayer: '',
        phone: '',
      },
      signRoles: ['ผู้รับสินค้า', 'ผู้ส่งสินค้า', 'ผู้รับเงิน', 'ผู้ตรวจสอบ'],
    }
  },
  computed: {
    companyName() {
      return 'บริษัท ภูมิรัชตพัฒน์ จำกัด'
    },
    companyAddress() {
      return '159/222 หมู่ 6 ตำบล ลำโพ อำเภอบางบัวทอง จังหวัด นนทบุรี 11110'
    },
    companyPhone() {
      return '082-294-4445'
    },
    companyTax() {
      return '0125566012671'
    },
    netTotal() {
      return this.arritem.reduce((total, data) => total + (Number(data.sumitem) || 0), 0)
    },
    thaiBahtText() {
      if (!this.netTotal) return 'ศูนย์บาทถ้วน'
      return `${this.convertToThaiBaht(this.netTotal)}ถ้วน`
    },
    displayItems() {
      const items = this.arritem || []
      const minRows = 9
      if (items.length >= minRows) return items
      return items.concat(Array.from({ length: minRows - items.length }, () => ({ empty: true })))
    },
  },
  mounted() {
    this.getData()
    this.getLetterhead()
    // this.GetNotify()
    // this.GetOrderAll(0)
  },
  methods: {
    // Commas(num) {
    //   return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    // },
    time(data) {
      moment.locale('th')
      return moment(data).format('DD MMMM YYYY HH:mm:ss')
    },
    times(data) {
      if (!data) return '-'
      const m = moment(data)
      return m.isValid() ? m.format('DD/MM/YYYY') : '-'
    },
    GetNotify() {
      this.$http
        .get('/order/Notify')
        .then(response => {
          // console.log(response.data)
          this.total = response.data.total
          this.waitingforcheck = response.data.waitingforcheck
          this.waitingforpayment = response.data.waitingforpayment
          this.paid = response.data.paid
          this.OrderSuccess = response.data.OrderSuccess
          this.completetrack = response.data.completetrack
          this.completewarehouse = response.data.completewarehouse
          this.cancel = response.data.cancel
        })
        .catch(error => console.log(error))
    },
    cancelbill() {
      this.$bvModal.msgBoxConfirm('ต้องการยกเลิกใบเสร็จ?', {
        title: 'ยืนยัน',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'warning',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      })
        .then(value => {
          if (value) {
            const obj = {
              _id: this.ID,
              statusbill: 2,
            }
            this.$http.post('/Billpay/update', obj)
              .then(response => {
                if (response.data) {
                  this.getData()
                }
              })
              .catch(err => {
                console.log(err)
                this.SwalError('ยกเลิกใบเสร็จไม่สำเร็จ')
              })
          }
        })
    },
    async getLetterhead() {
      try {
        const userData = JSON.parse(localStorage.getItem('userData') || '{}')
        const { data: res } = await this.$http.get('/general/show', {
          params: { agent_id: userData.agent_id },
        })
        if (res && res.status && res.data) {
          this.letterhead = {
            company_address: res.data.company_address || '',
            taxpayer: res.data.taxpayer || '',
            phone: res.data.thai_warehouse_tel || '',
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getData() {
      try {
        const params = {
          id: this.ID,
        }
        const { data: res } = await this.$http.get('/Billpay/getdataOne', { params })
        this.items = res
        const arritem = []
        if (this.items.difference && this.items.promotion) {
          console.log(this.items.payment - this.items.promotion.discount_pro - this.items.Service_fee)
          // console.log('1')
          // const item = (Number(this.items.payment) - this.items.promotion.discount_pro) - this.items.Service_fee + Number(this.items.difference)
          arritem.push({
            code: 'TR-1001', description: 'ค่าขนส่งสินค้า', quantity: 1, payment: (this.items.payment - this.items.promotion.discount_pro - this.items.Service_fee) + this.items.difference, difference: this.items.difference, sumitem: (this.items.payment - this.items.promotion.discount_pro - this.items.Service_fee),
          })
        } else if (this.items.difference) {
          arritem.push({
            code: 'TR-1001', description: 'ค่าขนส่งสินค้า', quantity: 1, payment: (this.items.payment - this.items.Shipping_cost - this.items.Service_fee) + this.items.difference, difference: this.items.difference, sumitem: (this.items.payment - this.items.Shipping_cost - this.items.Service_fee),
          })
        } else if (this.items.coupon && this.items.promotion) {
          console.log('2')
          arritem.push({
            code: 'TR-1001', description: 'ค่าขนส่งสินค้า', quantity: 1, payment: this.items.coupon.old_payment, difference: 0, sumitem: this.items.coupon.old_payment,
          })
        } else if (this.items.coupon) {
          console.log('3')
          arritem.push({
            code: 'TR-1001', description: 'ค่าขนส่งสินค้า', quantity: 1, payment: this.items.coupon.old_payment, difference: 0, sumitem: this.items.coupon.old_payment,
          })
        } else if (this.items.promotion) {
          console.log('4')
          arritem.push({
            code: 'TR-1001', description: 'ค่าขนส่งสินค้า', quantity: 1, payment: (this.items.payment - this.items.promotion.discount_pro) - this.items.Service_fee, difference: 0, sumitem: (this.items.payment - this.items.promotion.discount_pro) - this.items.Service_fee,
          })
        } else {
          console.log('5')
          arritem.push({
            code: 'TR-1001', description: 'ค่าขนส่งสินค้า', quantity: 1, payment: (this.items.payment - this.items.Shipping_cost - this.items.Service_fee), difference: 0, sumitem: (this.items.payment - this.items.Shipping_cost - this.items.Service_fee),
          })
        }
        console.log(arritem)
        // const arritem = [
        //   {
        //     code: 'TR-1001', description: 'ค่าขนส่งสินค้า', quantity: 1, payment: (this.items.payment - this.items.Shipping_cost - this.items.Service_fee),
        //   },
        //   // เพิ่มรายการอื่น ๆ ตามที่ต้องการ
        // ]
        if (this.items.Service_fee > 0) {
          // 'SE-1003'
          arritem.push({
            code: 'SE-1003',
            description: 'อื่น ๆ',
            quantity: 1,
            payment: this.items.Service_fee,
            difference: 0,
            sumitem: this.items.Service_fee,
          })
        }

        this.arritem = arritem
        this.texfullname = this.items.texfullname
        this.addresstex = this.items.addresstex
        this.telephone = this.items.telephone
        this.texnumber = this.items.texnumber
        this.$nextTick(() => {
          const el = this.$el.querySelector('.receipt-name-input')
          if (el) {
            el.style.height = 'auto'
            el.style.height = `${el.scrollHeight}px`
          }
          if (this.$route.query.print === '1') {
            this.printAfterReady()
          }
        })
        console.log(this.items)
      } catch (e) {
        console.log(e)
      }
    },
    Submit() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          const obj = {
            texfullname: this.texfullname,
            addresstex: this.addresstex,
            telephone: this.telephone,
            texnumber: this.texnumber,
            // eslint-disable-next-line no-underscore-dangle
            _id: this.items._id,

          }
          this.$http.post('/Billpay/update', obj)
            .then(() => {
              this.getData()
              this.Success('บันทึกใบเสร็จเรียบร้อย')
            })
            .catch(err => {
              this.SwalError(err)
            })
        }
      })
    },
    Submitokay() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.$bvModal.msgBoxConfirm('ต้องการบันทึกใบเสร็จ?', {
            title: 'ยืนยัน',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          })
            .then(value => {
              if (value) {
                const NewDate = new Date()
                const obj = {
                  // eslint-disable-next-line no-underscore-dangle
                  _id: this.items._id,
                  statusbill: 1,
                  dateokay: NewDate,
                }
                this.$http.post('/Billpay/update', obj)
                  .then(() => {
                    this.getData()
                    this.Success('บันทึกใบเสร็จเรียบร้อย')
                  })
                  .catch(err => {
                    this.SwalError(err)
                  })
              }
            })
        }
      })
    },
    printAfterReady() {
      setTimeout(() => this.printbill(), 250)
    },
    escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
    },
    buildReceiptHtml() {
      const origin = window.location.origin
      const rows = this.displayItems.map(item => {
        if (item.empty) {
          return '<tr><td>&nbsp;</td><td></td><td></td><td></td><td></td><td></td></tr>'
        }
        return `<tr>
          <td>${this.escapeHtml(item.code)}</td>
          <td>${this.escapeHtml(item.description)}</td>
          <td>${this.escapeHtml(item.quantity || 1)}</td>
          <td>${this.escapeHtml(this.Commas(item.payment))}</td>
          <td>${this.escapeHtml(this.Commas(item.difference))}</td>
          <td>${this.escapeHtml(this.Commas(item.sumitem))}</td>
        </tr>`
      }).join('')

      return `<!DOCTYPE html>
<html lang="th">
<head>
  <meta charset="UTF-8">
  <title>ใบเสร็จรับเงิน</title>
  <style>
    @font-face {
      font-family: 'TH Sarabun New';
      src: url('${origin}/fonts/THSarabun.ttf') format('truetype');
      font-weight: 400;
    }
    @font-face {
      font-family: 'TH Sarabun New';
      src: url('${origin}/fonts/THSarabun-Bold.ttf') format('truetype');
      font-weight: 700;
    }
    * { box-sizing: border-box; }
    html, body { margin: 0; padding: 0; background: #fff; }
    body { font-family: 'TH Sarabun New', 'THSarabunNew', Tahoma, sans-serif; color: #000; }
    .paper {
      width: 210mm;
      padding: 14mm 12mm 12mm;
      font-size: 18px;
      line-height: 1.35;
    }
    .header { display: flex; justify-content: space-between; gap: 16px; padding-bottom: 12px; }
    .brand { display: flex; flex-direction: column; gap: 8px; align-items: flex-start; }
    .brand img { width: 240px; height: auto; }
    .company h2 { margin: 0 0 4px; font-size: 22px; }
    .company p { margin: 0; max-width: 520px; line-height: 1.35; }
    .title { text-align: right; }
    .title h2 { margin: 0; font-size: 32px; }
    .title span { color: #555; font-size: 14px; }
    .meta { display: grid; grid-template-columns: 1.15fr 0.85fr; border: 0.6px solid #000; margin-top: 12px; }
    .box + .box { border-left: 0.6px solid #000; }
    .row { display: grid; grid-template-columns: 128px 1fr; gap: 8px; align-items: start; padding: 2px 10px; }
    .label { font-weight: 700; }
    .value { min-height: 0; font-weight: 400; }
    .name-flow { margin: 0; overflow-wrap: break-word; }
    table { width: 100%; border-collapse: separate; border-spacing: 0; margin-top: 12px; table-layout: fixed; border: 0.6px solid #000; }
    th, td { border: 0; border-right: 0.6px solid #000; padding: 4px 8px; text-align: center; vertical-align: middle; }
    th:last-child, td:last-child { border-right: 0; }
    th { background: #e6e6e6; font-weight: 600; border-bottom: 0.6px solid #000; }
    th small { display: block; font-weight: 400; color: #333; }
    .col-code { width: 14%; } .col-desc { width: 38%; } .col-qty { width: 10%; }
    .col-unit { width: 13%; } .col-disc { width: 12%; } .col-amt { width: 13%; }
    tbody tr { height: 24px; }
    .total td { border-top: 0.6px solid #000; }
    .net { display: flex; align-items: center; justify-content: space-between; }
    .net-label, .net strong { font-weight: 700; }
    .note { margin: 10px 0 8px; font-size: 15px; color: #444; }
    .pay { display: flex; flex-wrap: wrap; align-items: center; gap: 10px 14px; font-size: 16px; margin-bottom: 8px; }
    .chk { display: inline-block; width: 14px; height: 14px; border: 0.6px solid #000; margin-right: 6px; vertical-align: -2px; background: #fff; }
    .bank { display: grid; grid-template-columns: 1.4fr 1.2fr 1.1fr 1fr; gap: 16px; margin: 0 0 14px; font-size: 16px; }
    .bank span { display: flex; align-items: flex-end; white-space: nowrap; }
    .bank em { flex: 1; border-bottom: 1px dotted #000; margin-left: 8px; min-width: 80px; height: 1em; font-style: normal; }
    .signs { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; }
    .sign { border: 0.6px solid #000; min-height: 108px; padding: 6px; text-align: center; display: flex; flex-direction: column; }
    .sign p { margin: 0; font-weight: 700; }
    .sign .space { flex: 1; }
    .sign span { font-size: 14px; }
    @page { size: A4; margin: 0; }
  </style>
</head>
<body>
  <article class="paper">
    <header class="header">
      <div class="brand">
        <img src="${origin}/img/logo-p2-cargo.webp" alt="P2 CARGO">
        <div class="company">
          <h2>${this.escapeHtml(this.companyName)}</h2>
          <p>ที่อยู่ ${this.escapeHtml(this.companyAddress)}</p>
          <p>โทรศัพท์ ${this.escapeHtml(this.companyPhone)}</p>
          <p>เลขประจำตัวผู้เสียภาษี ${this.escapeHtml(this.companyTax)} / สำนักงานใหญ่</p>
        </div>
      </div>
      <div class="title">
        <h2>ใบเสร็จรับเงิน</h2>
        <span>Page 1 of 1</span>
      </div>
    </header>
    <section class="meta">
      <div class="box">
        <div class="row"><span class="label">นามลูกค้า</span><p class="value name-flow">${this.escapeHtml(this.texfullname || '-')} / เลขผู้เสียภาษี ${this.escapeHtml(this.texnumber || '-')}</p></div>
        <div class="row"><span class="label">ที่อยู่</span><span class="value">${this.escapeHtml(this.addresstex || '-')}</span></div>
        <div class="row"><span class="label">หมายเหตุ</span><span class="value">-</span></div>
        <div class="row"><span class="label">เลขที่ใบชำระเงิน</span><span class="value">${this.escapeHtml(this.items.itemnumber_text || '-')}</span></div>
        <div class="row"><span class="label">เบอร์โทร</span><span class="value">${this.escapeHtml(this.telephone || '-')}</span></div>
      </div>
      <div class="box">
        <div class="row"><span class="label">วันที่</span><span class="value">${this.escapeHtml(this.times(this.items.updated_at))}</span></div>
        <div class="row"><span class="label">เลขที่ใบเสร็จรับเงิน</span><span class="value">${this.escapeHtml(this.items.billnumber || '-')}</span></div>
        <div class="row"><span class="label">พนักงานขาย</span><span class="value">-</span></div>
        <div class="row"><span class="label">วันที่ครบกำหนด</span><span class="value">-</span></div>
        <div class="row"><span class="label">การชำระเงิน</span><span class="value">เงินสด</span></div>
        <div class="row"><span class="label">วิธีการจัดส่ง</span><span class="value">-</span></div>
      </div>
    </section>
    <table>
      <thead>
        <tr>
          <th class="col-code">รหัสสินค้า<small>Code</small></th>
          <th class="col-desc">คำอธิบาย<small>Description</small></th>
          <th class="col-qty">จำนวน<small>Qty</small></th>
          <th class="col-unit">ราคา/หน่วย<small>Unit</small></th>
          <th class="col-disc">ส่วนลด<small>Discount</small></th>
          <th class="col-amt">จำนวนเงิน<small>Amount</small></th>
        </tr>
      </thead>
      <tbody>
        ${rows}
        <tr class="total">
          <td colspan="3">(${this.escapeHtml(this.thaiBahtText)})</td>
          <td colspan="3"><div class="net"><span class="net-label">ยอดเงินสุทธิ</span><strong>${this.escapeHtml(this.Commas(this.netTotal))}</strong></div></td>
        </tr>
      </tbody>
    </table>
    <p class="note">ถ้าชื่อที่อยู่ไม่ถูกต้อง โปรดแจ้งภายใน 7 วันหลังจากเปิดบิล มิฉะนั้นจะถือว่าสมบูรณ์</p>
    <div class="pay">
      <span>ชำระโดย :</span>
      <span><i class="chk"></i>เงินสด</span>
      <span><i class="chk"></i>เช็คธนาคาร</span>
    </div>
    <div class="bank">
      <span>ธนาคาร <em></em></span>
      <span>สาขา <em></em></span>
      <span>เลขที่ <em></em></span>
      <span>ลงวันที่ ....../....../......</span>
    </div>
    <footer class="signs">
      <div class="sign"><p>ผู้รับสินค้า</p><div class="space"></div><span>วันที่ ....../....../......</span></div>
      <div class="sign"><p>ผู้ส่งสินค้า</p><div class="space"></div><span>วันที่ ....../....../......</span></div>
      <div class="sign"><p>ผู้รับเงิน</p><div class="space"></div><span>วันที่ ....../....../......</span></div>
      <div class="sign"><p>ผู้ตรวจสอบ</p><div class="space"></div><span>วันที่ ....../....../......</span></div>
    </footer>
  </article>
</body>
</html>`
    },
    receiptFileName() {
      const no = this.items.billnumber || this.ID || 'receipt'
      const date = this.times(this.items.updated_at)
      const safeDate = date && date !== '-' ? date.replace(/\//g, '-') : moment().format('DD-MM-YYYY')
      return `ใบเสร็จ-${no}-${safeDate}.pdf`
    },
    async printbill() {
      const old = document.getElementById('receipt-print-frame')
      if (old) old.remove()
      const iframe = document.createElement('iframe')
      iframe.id = 'receipt-print-frame'
      iframe.setAttribute('style', 'position:fixed;left:-220mm;top:0;width:210mm;height:297mm;border:0;opacity:0;pointer-events:none;')
      document.body.appendChild(iframe)
      const doc = iframe.contentDocument
      doc.open()
      doc.write(this.buildReceiptHtml())
      doc.close()

      const fontsReady = doc.fonts && doc.fonts.ready ? doc.fonts.ready.catch(() => {}) : Promise.resolve()
      const img = doc.querySelector('img')
      const logoReady = new Promise(resolve => {
        if (!img || img.complete) {
          resolve()
          return
        }
        img.onload = resolve
        img.onerror = resolve
      })
      await Promise.all([fontsReady, logoReady])
      await new Promise(resolve => setTimeout(resolve, 120))

      try {
        const [html2canvasMod, jspdfMod] = await Promise.all([
          import('html2canvas'),
          import('jspdf'),
        ])
        const html2canvas = html2canvasMod.default || html2canvasMod
        const jsPDF = jspdfMod.jsPDF || jspdfMod.default
        const paper = doc.querySelector('.paper')
        const canvas = await html2canvas(paper, {
          scale: 2,
          useCORS: true,
          backgroundColor: '#ffffff',
          logging: false,
        })
        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'mm',
          format: 'a4',
        })
        const pageW = 210
        const pageH = 297
        const imgData = canvas.toDataURL('image/jpeg', 0.95)
        let imgW = pageW
        let imgH = (canvas.height * pageW) / canvas.width
        if (imgH > pageH) {
          imgH = pageH
          imgW = (canvas.width * pageH) / canvas.height
        }
        const x = (pageW - imgW) / 2
        pdf.addImage(imgData, 'JPEG', x, 0, imgW, imgH)
        pdf.save(this.receiptFileName())
      } catch (e) {
        console.log(e)
        this.SwalError('สร้างไฟล์ใบเสร็จไม่สำเร็จ')
      } finally {
        iframe.remove()
      }
    },
    submitprint() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          let stringprint = ''
          // eslint-disable-next-line camelcase
          let check_print = null
          if (this.items.statusprint) {
            stringprint = 'บันทึกยังไม่พิมพ์?'
            // eslint-disable-next-line camelcase
            check_print = false
          } else {
            stringprint = 'บันทึกพิมพ์แล้ว?'
            // eslint-disable-next-line camelcase
            check_print = true
          }
          this.$bvModal.msgBoxConfirm(`${stringprint}`, {
            title: 'ยืนยัน',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          }).then(result => {
            if (result) {
              const obj = {
                texfullname: this.texfullname,
                addresstex: this.addresstex,
                telephone: this.telephone,
                texnumber: this.texnumber,
                statusprint: check_print,
                // eslint-disable-next-line no-underscore-dangle
                _id: this.items._id,

              }
              this.$http.post('/Billpay/update', obj)
                .then(() => {
                  this.getData()
                  this.Success('บันทึกใบเสร็จเรียบร้อย')
                })
                .catch(err => {
                  this.SwalError(err)
                })
              // console.log(this.items.statusprint)
            }
          })
        }
      })
    },
    checkpayment(data) {
      let item = data.payment - data.Shipping_cost - data.Service_fee
      if (data.coupon) {
        item = (data.payment - data.Shipping_cost - data.Service_fee) + data.coupon.discount_coupon
      } else if (data.promotion) {
        item = (data.payment - data.Shipping_cost - data.Service_fee) + data.promotion.discount_pro
      } else if (data.coupon && data.promotion) {
        item = (data.payment - data.Shipping_cost - data.Service_fee) + data.promotion.discount_pro + data.coupon.discount_coupon
      }
      return item
    },
    // showdata(data) {
    //   if (data.Service_fee > 0) {
    //     const item = 'ค่าขนส่งสินค้า อื่น ๆ'
    //     return item
    //   }
    //   return 'ค่าขนส่งสินค้า'
    // },
    cancelsubmit() {
      this.$bvModal.msgBoxConfirm('ปรับเป็นรอตรวจสอบ?', {
        title: 'ยืนยัน',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'warning',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      })
        .then(value => {
          if (value) {
            const obj = {
              // eslint-disable-next-line no-underscore-dangle
              _id: this.items._id,
              statusbill: 0,
              dateokay: null,
            }
            this.$http.post('/Billpay/update', obj)
              .then(() => {
                this.getData()
                this.Success('บันทึกใบเสร็จเรียบร้อย')
              })
              .catch(err => {
                this.SwalError(err)
              })
          }
        })
    },
    Success(mes) {
      this.$swal({
        icon: 'success',
        // title: '<h3 style="color: #141414">ทำรายการสำเร็จ</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    },
    GetOrderAll(type) {
      const params = {
        page: this.currentPage,
        perPage: this.perPage,
        type,
      }
      this.$http
        .get('/order/orderAll', { params })
        .then(response => {
          // console.log(response.data)
          this.items = response.data.data
          // this.totalRows = this.items.length
          this.totalRows = response.data.total
        })
        .catch(error => console.log(error))
    },
    resize(event) {
      // eslint-disable-next-line no-param-reassign
      event.target.style.height = 'auto'
      // eslint-disable-next-line no-param-reassign
      event.target.style.height = `${event.target.scrollHeight}px`
    },
    updateKeyword(id, note) {
      // console.log('Item ID:', id)
      // console.log('note:', note)
      const params = {
        id,
        note,
      }
      // console.log(params)
      this.$http
        .post('/order/updateNote', params)
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          // console.log(response.data)
        })
        .catch(error => console.log(error))
    },
    showModal(data) {
      this.pic = data
      this.$refs['my-modal'].show()
    },
    downloadImg() {
      const imageURL = '@/assets/images/anan-img/example/1.jpg'
      const link = document.createElement('a')
      link.href = imageURL
      link.download = 'image.jpg'
      link.click()
    },

    convertToThaiBaht(amount) {
      // แบ่งเป็นส่วนบาทและสตางค์
      const baht = Math.floor(amount)
      const satang = Math.round((amount - baht) * 100)

      // แปลงส่วนบาทเป็นข้อความ
      const bahtText = this.numToText(baht)
      const satangText = this.numToText(satang)
      // สร้างข้อความแสดงเงินในรูปแบบบาทและสตางค์
      let result = `${bahtText}บาท`

      if (satang > 0) {
        result += `${satangText}สตางค์`
      }

      return result
    },
    numToText(num) {
      // อาเรย์ของข้อความเลขภาษาไทย
      const thaiNumText = ['', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า']

      // อาเรย์ของข้อความหลัก
      const unitText = ['', 'สิบ', 'ร้อย', 'พัน', 'หมื่น', 'แสน', 'ล้าน']

      // แปลงตัวเลขเป็นข้อความ
      let result = ''
      const numStr = num.toString()

      // console.log(itemnum[1])
      const len = numStr.length

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < len; i++) {
        // eslint-disable-next-line radix
        const digit = parseInt(numStr[i])
        if (digit !== 0) {
          if (digit === 1 && (len - i - 1) === 1) {
            result += 'สิบ'
            thaiNumText[digit] = 'เอ็ด'
          } else if (digit === 2 && (len - i - 1) === 1) {
            result += 'ยี่สิบ'
            thaiNumText[len - i - 1] = 'เอ็ด'
          } else {
            result += thaiNumText[digit]
            result += unitText[len - i - 1]
          }
        }
      }

      return result
    },
    SwalError(mes) {
      this.$swal({
        icon: 'error',
        title: `<h3 style="color: #141414">${this.$t('key-298')}</h3>`,
        text: mes,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'TH Sarabun New';
  src: url('/fonts/THSarabun.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: 'TH Sarabun New';
  src: url('/fonts/THSarabun-Bold.ttf') format('truetype');
  font-weight: 700;
  font-style: normal;
}

.receipt-preview-wrap {
  margin-top: 1.25rem;
  padding: 1.25rem 0 2rem;
  background: #ececec;
  border-radius: 12px;
  overflow-x: auto;
}

.receipt-preview-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  max-width: 210mm;
  margin: 0 auto 1rem;
  padding: 0 8px;

  h4 {
    font-weight: 700;
    color: #111;
  }

  p {
    color: #555;
    font-size: 13px;
  }
}

.receipt-example-link {
  background: #111;
  color: #fff !important;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.receipt-paper {
  width: 210mm;
  min-width: 210mm;
  min-height: 297mm;
  margin: 0 auto;
  padding: 14mm 12mm 12mm;
  background: #fff;
  color: #000;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.14);
  font-family: 'TH Sarabun New', 'THSarabunNew', Tahoma, sans-serif;
  font-size: 18px;
  line-height: 1.35;

  h1,
  h2,
  h3,
  h4,
  p,
  table,
  th,
  td,
  span,
  label {
    font-family: inherit;
    color: #000;
  }

  h1,
  h2,
  h3,
  h4 {
    line-height: 1.25;
  }
}

.receipt-header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 12px;
}

.receipt-brand {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
}

.receipt-logo {
  width: 240px;
  height: auto;
  object-fit: contain;
}

.receipt-company {
  h2 {
    margin: 0 0 4px;
    font-size: 22px;
    font-weight: 700;
    color: #000;
  }

  p {
    margin: 0;
    color: #000;
    font-weight: 400;
    max-width: 520px;
    line-height: 1.35;
  }
}

.receipt-title {
  text-align: right;
  flex: 0 0 auto;

  h2 {
    margin: 0;
    font-size: 32px;
    font-weight: 700;
    letter-spacing: 0.5px;
    color: #000;
  }

  span {
    color: #555;
    font-size: 14px;
  }
}

.receipt-meta {
  display: grid;
  grid-template-columns: 1.15fr 0.85fr;
  border: 1px solid #000;
  margin-top: 12px;
}

.receipt-box {
  padding: 0;

  + .receipt-box {
    border-left: 1px solid #000;
  }
}

.receipt-row {
  display: grid;
  grid-template-columns: 128px 1fr;
  gap: 8px;
  align-items: start;
  padding: 2px 10px;
}

.receipt-label {
  font-weight: 700;
  color: #000;
}

.receipt-value,
.receipt-field,
.receipt-tax-prefix {
  font-weight: 400;
}

.receipt-value {
  min-width: 0;
  min-height: 0;
}

.receipt-field {
  min-width: 0;
}

.receipt-name-flow {
  margin: 0;
  line-height: 1.45;
  overflow-wrap: break-word;
  word-break: normal;
}

.receipt-edit-text {
  display: inline;
  outline: none;
}

.receipt-no {
  font-weight: 400;
  color: #000;
}

.receipt-link {
  font-weight: 400;
  color: #000 !important;
  text-decoration: underline;
}

.receipt-input,
.receipt-paper ::v-deep .form-control {
  display: block;
  width: 100%;
  height: auto !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  padding: 0 !important;
  min-height: 1.4em !important;
  background: transparent !important;
  font-size: 18px !important;
  font-weight: 400 !important;
  color: #000 !important;
  line-height: 1.4;

  &:focus {
    box-shadow: none !important;
    background: #f7f7f7 !important;
  }
}

.receipt-textarea {
  min-height: 1.4em;
  resize: none;
}

.receipt-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  margin-top: 12px;
  table-layout: fixed;
  border: 1px solid #000;

  tr,
  th,
  td {
    border-radius: 0 !important;
  }

  th,
  td {
    border-left: 1px solid #000 !important;
    border-right: 1px solid #000 !important;
    border-top: 0 !important;
    border-bottom: 0 !important;
    padding: 4px 8px;
    vertical-align: middle;
    text-align: center !important;
  }

  thead th {
    background: #e6e6e6;
    font-weight: 600;
    text-align: center !important;
    border-top: 1px solid #000 !important;
    border-bottom: 1px solid #000 !important;

    small {
      display: block;
      width: 100%;
      font-weight: 400;
      color: #333;
      font-size: 13px;
      text-align: center !important;
    }
  }

  .col-code { width: 14%; text-align: center; }
  .col-desc { width: 38%; text-align: center; }
  .col-qty { width: 10%; text-align: center; }
  .col-unit { width: 13%; text-align: center; }
  .col-disc { width: 12%; text-align: center; }
  .col-amt { width: 13%; text-align: center; }

  tbody tr {
    height: 24px;
  }

  .receipt-total-row td {
    border-top: 1px solid #000 !important;
    border-bottom: 1px solid #000 !important;
  }
}

.receipt-total-row td {
  background: #fff;
}

.receipt-baht-text {
  font-weight: 400;
  text-align: center;
}

.receipt-net-cell {
  padding: 4px 8px !important;
}

.receipt-net-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 0;
  font-weight: 400;

  strong {
    font-weight: 700;
  }
}

.receipt-net-label {
  font-weight: 700;
  white-space: nowrap;
}

.receipt-note {
  margin: 10px 0 8px;
  font-size: 15px;
  color: #444;
}

.receipt-pay {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 14px;
  font-size: 16px;
  margin-bottom: 8px;

  span {
    display: inline-flex;
    align-items: center;
  }
}

.receipt-chk {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 1px solid #000;
  border-radius: 0;
  margin-right: 6px;
  background: #fff;
}

.receipt-bank {
  display: grid;
  grid-template-columns: 1.4fr 1.2fr 1.1fr 1fr;
  gap: 16px;
  margin: 0 0 14px;
  font-size: 16px;
  color: #000;

  span {
    display: flex;
    align-items: flex-end;
    white-space: nowrap;
  }

  em {
    flex: 1;
    border-bottom: 1px dotted #000;
    margin-left: 8px;
    min-width: 80px;
    height: 1em;
    font-style: normal;
  }
}

.receipt-signs {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.receipt-sign {
  border: 1px solid #000;
  min-height: 108px;
  padding: 6px;
  text-align: center;
  display: flex;
  flex-direction: column;

  p {
    margin: 0;
    font-weight: 700;
  }

  span {
    font-size: 14px;
  }
}

.receipt-sign-space {
  flex: 1;
}

@media only screen and (max-width: 900px) {
  .receipt-paper {
    min-height: auto;
    padding: 16px;
  }

  .receipt-header,
  .receipt-meta,
  .receipt-signs {
    grid-template-columns: 1fr;
    display: grid;
  }

  .receipt-header {
    display: grid;
  }

  .receipt-title {
    text-align: left;
  }

  .receipt-box + .receipt-box {
    border-left: 0;
    border-top: 1px solid #000;
  }

  .receipt-row {
    grid-template-columns: 96px 1fr;
  }
}

@media only screen and (max-width: 600px) {
  .text-mobile {
    font-size: 10px !important;
  }

  .receipt-preview-bar {
    flex-direction: column;
    align-items: flex-start;
  }
}

</style>
